import axiosHelper from '@/helpers/axiosHelper';

export default axiosHelper.mergeAxiosRequestTransformerWithDefaults(
  (data: any, headers: any): any => {
    const projectId = window.localStorage.getItem('projectId');

    Object.assign(
      headers.common,
      {
        'WIDGET-AUTH-TOKEN': window.localStorage.getItem(`${projectId}.accessToken`),
        'WIDGET-AUTH-PROJECT-ID': projectId,
      }
    );

    return data;
  }
);
